<div class="flex h-full w-full flex-1 items-end py-2">
  <div class="mx-lg">
    <ng-content></ng-content>
  </div>
</div>
